module.exports = __webpack_public_path__ + "img/3.1b425ccb.png";